import React from 'react';
const Hero = () => {
  return <section className="pt-32 pb-20 px-6 md:px-12 bg-gradient-to-b from-teal-50 to-white" data-id="element-112">
      <div className="max-w-7xl mx-auto" data-id="element-113">
        <div className="flex flex-col md:flex-row items-center" data-id="element-114">
          <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-115">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-teal-900 leading-tight mb-6" data-id="element-116">
              Give Your Clients the Trauma-Informed, Nervous System Healing
              Tools They've Always Needed
            </h1>
            <p className="text-xl text-teal-800 mb-8" data-id="element-117">
              <span className="font-semibold" data-id="element-118">
                Get better client outcomes, increase retention, and free up your time
              </span>{' '}
—without creating a single new resource.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-119">
              <a href="https://www.neurotoned.com/offers/7S2eZfYL?coupon_code=PROFESSIONALACCESSPASS" className="bg-teal-700 hover:bg-teal-800 text-white py-3 px-8 rounded-md font-medium text-lg transition duration-300 text-center" data-id="element-120">
                Secure Your Spot
              </a>
              <a href="https://calendly.com/madisonstarr/30min" className="border-2 border-teal-700 text-teal-700 hover:bg-teal-50 py-3 px-8 rounded-md font-medium text-lg transition duration-300 text-center" data-id="element-121">
                Book a Free Call
              </a>
            </div>
            {/* Offer stack moved from problem section */}
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-md mb-6" data-id="element-122">
              <div className="text-center mb-4" data-id="element-123">
                <span className="inline-block px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium mb-2" data-id="element-124">
                  Limited Time Offer
                </span>
                <h3 className="text-xl font-bold text-teal-900" data-id="element-125">
                  Only 10 spots available at this price!
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-126">
                <li className="flex items-start" data-id="element-127">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-128">✓</span>
                  <span data-id="element-129">Unlimited client accounts</span>
                </li>
                <li className="flex items-start" data-id="element-130">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-131">✓</span>
                  <span data-id="element-132">Full practitioner access</span>
                </li>
                <li className="flex items-start" data-id="element-133">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-134">✓</span>
                  <span data-id="element-135">Biweekly live support calls</span>
                </li>
                <li className="flex items-start" data-id="element-136">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-137">✓</span>
                  <span data-id="element-138">Directory listing</span>
                </li>
                <li className="flex items-start" data-id="element-139">
                  <span className="text-teal-700 font-bold mr-2" data-id="element-140">✓</span>
                  <span data-id="element-141">
                    Price increases to $1,099 after first 10 practitioners
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-142">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wZv7vuEJVgUD5XfZjH1Az4/Adobe_Express_-_file_%281%29.png" alt="Neurotoned Platform and Materials" className="rounded-lg shadow-xl max-w-full h-auto" data-id="element-143" />
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;